import React, { Component } from 'react';
import './PoolImport.css';
import { withRouter, Link } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import Stepper from '../../../components/UI/Stepper/Stepper';
import AddJob from '../../../components/Recruiter/AddJob/AddJob';
import AddCandidates from '../../../components/Recruiter/AddCandidates/AddCandidates';
import { CandidatesData } from '../../../data/candidates';
import DashboardBar from '../../../components/Recruiter/DashboardBar/DashboardBar';
import axios from '../../../services/axios-service';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import PoolRecruiter from '../PoolRecruiter/PoolRecruiter';
import Button from '../../../components/UI/Button/Button';
import { checkValidity } from '../../../shared/utility';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import * as actions from '../../../store/actions/index';
import addCollaboratorIcon from '../../../assets/images/plus.svg';
import InviteCollaborator from '../../../components/Recruiter/InviteCollaborator/InviteCollaborator';
import getS3ImageUrl from '../../../lib/s3FileHandler';
import ProfileImage from '../../../components/UI/ProfileImage/ProfileImage';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';
import Icon from '../../../components/UI/Icon/Icon';
import AWS from 'aws-sdk';
import config from '../../../config';

/**
 * @desc shows the field to add new jobs
 * @param props
 * @return DOMElement
 */
function StepTitle(props) {
  const currentStep = props.currentStep;
  const collaboratorAvatars = props.updatedCollaborators.map((collaborator,index)=> {
    const fullName = collaborator.firstName + " " + collaborator.lastName;
    let tooltipText = fullName;
    if(parseInt(collaborator.userId) === parseInt(props.jobRecUserId)) {
      tooltipText += " / Owner";
      props.updatedCollaborators.splice(index,1);
      props.updatedCollaborators.unshift(collaborator);
      
    }
    if(index<=3){
      return <ProfileImage 
        className="updated-collaborator-image" 
        imageUrl={collaborator.imageUrl} 
        initials={collaborator.initials}
        tooltipText={ tooltipText }
      />
      
    } else{
      return <div className="recruiter-collaborator-more-list">
        <ProfileImage 
        className="updated-collaborator-image more" 
        imageUrl={collaborator.imageUrl} 
        initials={collaborator.initials}
      />
        <span>{fullName}</span>
      </div>;
    }
  });

  const collaboratorImages = collaboratorAvatars.splice(0, 4);
  const moreRecruiterCollaborators = <div className="rec-more-collaborator-list">{collaboratorAvatars}</div>

  if (currentStep === 0) {
    return <h1 className="pool-import-title step-1">Add Job Details</h1>;
  } else if (currentStep === 1) {
  return (
    <div>
      <MediaQuery query="(max-device-width: 768px)">
      <h1 className="pool-import-title step-2">Add Candidate(s) to <br/>
     {props.jobTitle}  {props.jobBH}</h1>
     <span className="pool-import-title-company-name">{props.companyName}</span>
      </MediaQuery>
      <MediaQuery query="(min-device-width: 768px)">
      <h1 className="pool-import-title step-2">{`Add Candidate(s) to ${props.jobTitle}  ${props.jobBH}`}</h1>
      <span className="pool-import-title-company-name">{props.companyName}</span>
      </MediaQuery>
    </div>
  )
  }
  else { (currentStep === 2) 
    return(
      <div className="pool-import-title-tab">
        <h1 className="pool-import-title step-3">{`Candidate list for  ${props.jobTitle} ${props.jobBH}`}</h1>
        <span className="list-company-name">{props.companyName}</span>
        {props.jobRecUserId == props.recruiterDetails.user_id ? 
          <MediaQuery query="(min-device-width: 768px)">
            <div className="rec-collaborator-icon-wrapper">
              <img className="rec-collaborator-icon" src={addCollaboratorIcon} onClick={props.handleAddCollaborator}/>
              <span className="rec-collaborator-icon-tooltip">
                Add / Remove Collaborator
              </span>
            </div>
          </MediaQuery>
        :""}
        {collaboratorImages}
        {(props.updatedCollaborators.length > 4) ? <div className="rec-more-collaborator"><div className="rec-more-collaborator-count">+{ props.updatedCollaborators.length-4}</div> {moreRecruiterCollaborators}</div> : null}
      </div>
    );
  }
}


/**
 * @desc shows the field to add new jobs or add candidate to specific job title
 * @param props
 * @return DOMElement
 */
function Steps(props) {
  const currentStep = props.currentStep;
  if (currentStep === 0) {
    return <AddJob 
              handleJobDetailsChange={props.handleJobDetailsChange} 
              handleKeyPressBHJobId={props.handleKeyPressBHJobId}
              handleKeyPressCmpyId={props.handleKeyPressCmpyId}
              handleKeyPressJobTitle={props.handleKeyPressJobTitle} 
              handleClientDetailsChange={props.handleClientDetailsChange} 
              errorMessage={props.errorMessage} 
              errorPosition={props.errorPosition}
              clientDetails={props.clientDetails}
              handleFetchClientDetails={props.handleFetchClientDetails} />;
  } else if (currentStep === 1) {
  return <AddCandidates 
            candidates={props.candidates} 
            fileName={props.fileName}
            getCandidate={props.getCandidate} 
            networkError={props.networkError}
            cvUpload = {props.cvUpload}
            errorPosition={props.errorPosition}
            handleKeyPressCandidateId={props.handleKeyPressCandidateId} 
            deleteCandidateModal = {props.deleteCandidateModal} 
            handleCandidateIdChange={props.handleCandidateIdChange} 
            handleCandidateIdBlur = {props.handleCandidateIdBlur}
            errorPositioncandidateId={props.errorPositioncandidateId}
            errorPositionEmail = {props.errorPositionEmail}
            handleCandidateEmailChange = {props.handleCandidateEmailChange}
            addFile = {props.addFile}
            handleRemoveFile = {props.handleRemoveFile}
            handleAttachClick = {props.handleAttachClick}
            progressPercent = {props.progressPercent}
            handleCandidateEmailBlur = {props.handleCandidateEmailBlur}
            jobTitle={props.jobTitle} 
            candidateId={props.candidateId}
            candidateEmail={props.candidateEmail}
            importLoader={props.importLoader}
            importButtonDisable={props.importButtonDisable}
            fileUploaded = {props.fileUploaded}
            emailsList={props.emailsList}
            disableCandidateFields = {props.disableCandidateFields}
            addCandidatebutton = {props.addCandidatebutton}
            />;
  }
  else {
    return <PoolRecruiter 
              jobId={props.jobId} 
              jobTitle={props.jobTitle} 
              jobBH={props.jobBH} 
              handleAddCandidate={props.handleAddCandidate}
              candidates={props.candidates}
              passDeleteCandidate={props.passDeleteCandidate} 
              continueClicked={props.continueClicked}
             />
  }
}
/**
 * @desc Button to save and continue the added job details or cancel
 * @param props
 * @return null
 */
function StepButtons(props) {
  const currentStep = props.currentStep;
  const saveEnable = (props.candidates.length == 0 || props.candidates.length == undefined || props.candidates[0].message)?(props.disabled):"";
  const enableClassName = (props.candidates.length == 0 || props.candidates.length == undefined)?(props.classDisabled):"save";
  if (currentStep === 0) {
    return <div className="form-buttons step-1">
      <Link to="/recruiter/dashboard"><Button 
              size="small" 
              className="add-job-previous-button" 
              buttonicon="previous-icon"  /></Link>
      <Button 
        className="Save-for-Later" 
        disabled={props.clientDetails?false:true}
        onClick={ () => props.onClickNext('save-later') }>Save for Later</Button>
      <Button 
        disabled={props.clientDetails?false:true}
        className="Save-and-Continue"
        onClick={ () => props.onClickNext('save-continue') } >Save and Continue</Button>
    </div>;
  } else if (currentStep === 1) {
    return <div className="form-buttons step-2">
      {/* Mobile View Section starts */}	
      <MediaQuery query="(max-device-width: 769px)">
        {/* <div className="stepper-previous-button">
            <Button onClick={ ()=> props.onClickPrevious() } size="small" className="joblist-previous-button" buttonicon="previous-icon"  />
        </div> */}
        <div className="stepper-buttons">
          <Button 
            className="cancel" 
            onClick={ props.handleCancelImportCandidate } >Save for Later</Button>
          <Button 
            className={enableClassName} 
            onClick={ props.handleComplete } 
            disabled={saveEnable}>Continue</Button>
        </div>
      </MediaQuery>
      {/* Mobile View Section ends */}

      {/* Desktop View Section starts */}	
      <MediaQuery query="(min-device-width: 769px)">
        <div className="stepper-previous-button">
            <Button 
              onClick={ ()=> props.onClickPrevious() } 
              size="small" 
              className="joblist-previous-button" 
              buttonicon="previous-icon"  />
        </div>
        <div className="stepper-buttons">
          <Button 
            className="cancel"
            onClick={ props.handleCancelImportCandidate } >Save for Later</Button>
          <Button 
            className={enableClassName} 
            onClick={ props.handleComplete } 
            disabled={saveEnable}>Continue</Button>
        </div>
      </MediaQuery>
      {/* Desktop View Section ends */}	
    </div>;
  } else {
    return ''
  }
}

/**
* @desc import candidate to specific job title
* @version 0.1.0
* @author Jamshith,Praveen George,Amrutha,Lakshmikanth V
*/
class PoolImport extends Component {

  constructor(props) {
    super(props);
    let currentStep = 0;
    let stepTwoFlag = false;
    if(props.match.params.jobId && props.match.params.jobId !== null) {
      currentStep = 2;
      stepTwoFlag = false;
   }

    this.state = {
      steps: [{
        title: 'Add Job',
        href: '/pool/import',
        onClick: (e) => {
          e.preventDefault()
        }
      }, {
        title: 'Add Candidates',
        href: '/pool/import',
        onClick: (e) => {
          e.preventDefault()
        }
      },{
        title: 'Review Profiles',
        href: '/pool/import',
        onClick: (e) => {
          e.preventDefault()
        }
      }],
      currentStep: currentStep,
      pool: {
        jobTitle: '',
        jobId: '',
        jobBH: '',
        companyBHId:'',
        candidateId:"",
        candidates: []
      },
      clientDetails:'',
      candidates: CandidatesData,
      showCancelWarning: false,
      errorMessage: null,
      errorPosition: [],
      candidateError:null,
      deleteModal:false,
      candidateIndex:"",
      showCancelWarningImportCandidate: false,
      stepOneFlag: false,
      stepTwoFlag: stepTwoFlag,
      importButtonDisable:true,
      importLoader:false,
      searchCandidateId: "",
      searchCandidateEmail:'',
      progressPercent:{},
      profileImage: (this.props.userImageSignedUrl) ? this.props.userImageSignedUrl : '',
      addCollaboratorModal:false,
      collaboratorSearchParam:"",
      collaboratorSearchResults:[],
      CollaboratorList:[],
      collaborators:[],

      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      updatedCollaborators:[],
      adddedCollaborators:[],
      deletedCollaborators:[],
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      fileName:'',
      s3Key:'',
      fileUploaded: false,
      errorPositioncandidateId:'',
      errorPositionEmail:'',
      emailsList: [],
      addedCount: 0,
      removedCount: 0,
      networkError:"",
      deleteImportCandidate:false,
      showContinueModal:false,
      disableCandidateFields: false,
      addCandidatebutton: false,
      continueClicked: false
    };
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrevious = this.onClickPrevious.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCancelCancel = this.handleCancelCancel.bind(this);
    this.handleCancelWarningShow = this.handleCancelWarningShow.bind(this);
    this.handleComplete = this.handleComplete.bind(this);
    this.handleJobDetailsChange = this.handleJobDetailsChange.bind(this);
    this.handleClientDetailsChange = this.handleClientDetailsChange.bind(this);
    this.handleCandidateIdChange =this.handleCandidateIdChange.bind(this);
    // this.handleSuccessfulHide = this.handleSuccessfulHide.bind(this);
    this.handleCancelImportCandidate = this.handleCancelImportCandidate.bind(this);
    this.getClientDetails =this.getClientDetails.bind(this);
    this.handleFetchClientDetails = this.handleFetchClientDetails.bind(this);
    this.handleAddCollaborator=this.handleAddCollaborator.bind(this);
    this.onSelectCollaborator=this.onSelectCollaborator.bind(this);
    this.handleClearCollaboratorSearchParam =this.handleClearCollaboratorSearchParam.bind(this);
  }
/**
 * @desc shows previous page based on conditions
 * @param null
 * @return null
 */
  onClickPrevious() 
  { 
    if (this.state.stepOneFlag == true) {
      const { steps, currentStep } = this.state;
      const pool =  {
        // jobTitle: '',
        // jobId: '',
        // jobBH: '',
        // companyBHId:'',
        // candidateId:"",
        // candidates: []
        ...this.state.pool
      };
      this.setState({
        currentStep: currentStep - 1,
        pool:pool,
        clientDetails:'',
        errorPositioncandidateId: '',
        errorPositionEmail:''
      });
    }
    else if (this.state.stepTwoFlag == true) {
      const { steps, currentStep } = this.state;
      this.setState({
        currentStep: currentStep + 1,
      });
    }
    else {
      window.history.back()
    }
  }
/**
 * @desc Validate and pass added job details to create job function
 * @param null
 * @return null
 */
  onClickNext = (navControl) => {
      
    if(!checkValidity(this.state.pool.jobBH,'isNumeric') || this.state.pool.jobBH.length > 15 || this.state.pool.jobTitle.trim() === "" 
    || this.state.pool.companyBHId.trim() === "" || this.state.pool.companyBHId.length > 15 ){
      let errorPosition = [];
      if(!checkValidity(this.state.pool.jobBH,'isNumeric') || this.state.pool.jobBH.length > 15) {
        errorPosition = errorPosition.concat('jobBH');
      } 
      if(this.state.pool.jobTitle.trim() === "") {
        errorPosition = errorPosition.concat('jobTitle');
      }
      if(this.state.pool.companyBHId.trim() === "" || this.state.pool.companyBHId.length > 15) {
        errorPosition = errorPosition.concat('companyBHId');
      }
      
      this.setState({
        errorPosition: errorPosition
      });

    }
    
    else {
      this.postJobDetails({
        jobTitle:this.state.pool.jobTitle,
        jobBH:this.state.pool.jobBH,
        companyId:this.state.pool.companyBHId,
        userId:this.props.recruiterDetails.user_id,
        permittedId:this.state.clientDetails.company_contact_id
      }, navControl);
    }
  }
  


  handleFetchClientDetails = (event) =>{
    event.preventDefault();
    if(!checkValidity(this.state.pool.jobBH,'isNumeric') || this.state.pool.jobBH.length > 15 || this.state.pool.jobTitle.trim() === "" 
    || this.state.pool.companyBHId.trim() === "" || this.state.pool.companyBHId.length > 15 ){
      let errorPosition = [];
      if(!checkValidity(this.state.pool.jobBH,'isNumeric') || this.state.pool.jobBH.length > 15) {
        errorPosition = errorPosition.concat('jobBH');
      } 
      if(this.state.pool.jobTitle.trim() === "") {
        errorPosition = errorPosition.concat('jobTitle');
      }
      if(this.state.pool.companyBHId.trim() === "" || this.state.pool.companyBHId.length > 15) {
        errorPosition = errorPosition.concat('companyBHId');
      }
      
      this.setState({
        errorPosition: errorPosition
      });

    }
    else {
      this.getClientDetails();
    }
    
  }
  handleAddCollaborator = () => {
    this.setState({addCollaboratorModal:true,adddedCollaborators:[],deletedCollaborators:[]});
    this.getCollaboratorList();
  }
  onSelectCollaborator = (collaborator)=> {
    let selectedCollaborator = collaborator;  
    selectedCollaborator.initials = selectedCollaborator.firstName.charAt(0) + selectedCollaborator.lastName.charAt(0);
    selectedCollaborator.imageUrl = "";

    if(selectedCollaborator.userImage && selectedCollaborator.userImage !== null && selectedCollaborator.userImage !== "") {
      getS3ImageUrl(selectedCollaborator.userImage, this.props.user)
        .then((response) => {
          const collaboratorsCurrent = [...this.state.collaborators];
          const collaboratorObject = collaboratorsCurrent.find((collaborator) => collaborator.userId === selectedCollaborator.userId);
          const collaboratorIndex = collaboratorsCurrent.findIndex((collaborator) => collaborator.userId === selectedCollaborator.userId);
          collaboratorObject.imageUrl = response;
          collaboratorsCurrent[collaboratorIndex] = collaboratorObject;
          this.setState({ collaborators:collaboratorsCurrent });
        });
    }
    
    const collaborators = [...this.state.collaborators, selectedCollaborator];
    this.setState({ collaborators:collaborators,
                    collaboratorSearchParam: "", 
                    collaboratorSearchResults:[] 
                  });
  }
  getCollaboratorList= () =>{
    axios.get("/galaxy/user").then(response => {  
      
      if(response.data.length>0) {
        // const collaboratorsResponse = [...this.state.collaborators];
        // const collaboratorsUserIds = collaboratorsResponse.map(collaboratorObj => parseInt(collaboratorObj.userId));
        const CollaboratorList = response.data.filter(collaborator => collaborator.userId !== this.props.recruiterDetails.user_id); 
        CollaboratorList.map((collaborator) => collaborator.title = collaborator.firstName + " " + collaborator.lastName);
        this.setState({ CollaboratorList : CollaboratorList }); 
      }
    })
    .catch((error) => {
      ConsoleLog('error',error);
    });
  }

  updateCollaborator = () => {
    const adddedCollaborators = [...this.state.adddedCollaborators];
    const deletedCollaborators =[...this.state.deletedCollaborators];
    //ConsoleLog("adddedCollaborator",adddedCollaborator,"deletedCollaborator",deletedCollaborator)

    let addedcollaboratorsDetails = [];
    let deletedcollaboratorsDetails = [];
    
    if(adddedCollaborators.length>0) {
      for(var i=0;i<adddedCollaborators.length;i++) {
        addedcollaboratorsDetails.push({
          collaboratorId: adddedCollaborators[i].userId, 
          jobId: this.state.pool.jobId,
          userId:this.props.recruiterDetails.user_id,
          userName:this.props.recruiterDetails.user_fname + " " + this.props.recruiterDetails.user_lname
        });
      }
      axios.post("/galaxy/job/" + this.state.pool.jobId + "/collaborator",JSON.stringify(addedcollaboratorsDetails))
      .then((response)=>{
        this.setState({updatedCollaborators:this.state.collaborators,addCollaboratorModal:false});
      })
      .catch((error) => {
        ConsoleLog('error',error);
        throw error;
      });
    }
    if(deletedCollaborators.length>0) {
      for(var i=0;i<deletedCollaborators.length;i++) {
        deletedcollaboratorsDetails.push({
          collaboratorId: deletedCollaborators[i].userId, 
          jobId: this.state.pool.jobId,
          userId:this.props.recruiterDetails.user_id,
          userName:this.props.recruiterDetails.user_fname + " " + this.props.recruiterDetails.user_lname
        });
      }
      axios.delete("/galaxy/job/" + this.state.pool.jobId + "/collaborator", {data: JSON.stringify(deletedcollaboratorsDetails)})
      .then((response)=> {    
        this.setState({updatedCollaborators:this.state.collaborators,addCollaboratorModal:false});
      })
      .catch((error) => {
        ConsoleLog('error',error);
        throw error;
      });
    }
    //ConsoleLog("addedcollaboratorsDetails",addedcollaboratorsDetails,"deletedcollaboratorsDetails",deletedcollaboratorsDetails)
    
  }


  cancelAddCollaborator= () => {
    const updatedCollaborators = [...this.state.updatedCollaborators]
    this.setState({addCollaboratorModal:false,collaborators:updatedCollaborators});
  }

  collaboratorSearchHandler = (e) => {   
    const collaboratorSearchParam = e.target.value;
    const selectedCollaborators = [...this.state.collaborators];
    const collaboratorList = [...this.state.CollaboratorList];
    const collaboratorsUserIds = selectedCollaborators.map(collaboratorObj => parseInt(collaboratorObj.userId));
    const nonSelectedCollaborators = collaboratorList.filter(collaborator =>  !collaboratorsUserIds.includes(collaborator.userId));
    let collaboratorSearch = [];
    if(collaboratorSearchParam !== null && collaboratorSearchParam !== "") {      
      collaboratorSearch = nonSelectedCollaborators.filter(collaborator => 
        parseInt(collaborator.userId) !== parseInt(this.props.recruiterDetails.user_id) &&
        (collaborator.email.toLowerCase().includes(collaboratorSearchParam.toLowerCase())||
        collaborator.firstName.toLowerCase().includes(collaboratorSearchParam.toLowerCase()) || 
        collaborator.lastName.toLowerCase().includes(collaboratorSearchParam.toLowerCase()) ||
        (collaborator.firstName.toLowerCase() + " "  + collaborator.lastName.toLowerCase()).includes(collaboratorSearchParam.toLowerCase()))
      );
    }
    this.setState({ collaboratorSearchParam: collaboratorSearchParam, collaboratorSearchResults: collaboratorSearch});      
  }

  handleClearCollaboratorSearchParam = () => {
    this.setState({ collaboratorSearchParam: "", collaboratorSearchResults:[] });
  }
  deleteCollaborator=(collaboratorId)=> {
    const collaborators=[...this.state.collaborators.filter(collaborator=>
      parseInt(collaborator.userId) !== parseInt(collaboratorId))];
    this.setState({collaborators:collaborators});

  }

  getClientDetails =() => {
    axios.get("/galaxy/company/" + this.state.pool.companyBHId).then(response => {  
      if(response.data.length>0) {
        this.setState({ clientDetails : response.data[0] }); 

        let permittedContact = {
          permittednoofcandidates: 0,
          permitted_contact_fname: response.data[0].user_fname,
          permitted_contact_lname: response.data[0].user_lname,
          permitted_contact_bh_id: response.data[0].user_bh_id,
          permitted_contact_email: response.data[0].user_email,
          permitted_contact_created: response.data[0].user_created_dt
        }
        this.props.onSetPermittedUser(permittedContact);
      }    
      else {
        let errorPosition = [];
        errorPosition = errorPosition.concat('UnknownCompanyBHId');
        this.setState({ errorPosition });
      }
    })
    .catch((error) => {
      ConsoleLog('error',error);
    });
  }

  /**
   * @desc creating Job with added details
   * @param jobDetails
   * @return null
   */
  postJobDetails = (jobDetails, navControl) => { 
    axios.post("/galaxy/job", JSON.stringify(jobDetails))
      .then((response) => {   
      const jobSaved = (response.data.message === "Job already exists" || response.data.message === "Client does not exists") ? false : true;
      const { steps, currentStep } = this.state;
      // const errorMessage = (!showJobSuccessful) ? ((response.data.message !== "Job already exists" ) ? "Please check the Company Bullhorn ID and try again" : response.data.message ) : null;
      // this.setState({ showJobSuccessful:showJobSuccessful, errorMessage: errorMessage, errorPosition: [] });
        const toastMessage = (response.data.message === "Job Title Inserted Sucessfully")?"Job saved successfully":"Job already exists";
        const toastVariant = jobSaved?"success":"error";
        this.setState({
          isShowToast:true,
          toastMessage:toastMessage,
          toastVariant:toastVariant,
          toastId: "tid" + (new Date()).getTime() 
        });
      if(jobSaved) {        
        let pool = {...this.state.pool};
        pool.jobId = response.data.job_id;
        if(navControl === "save-later") {
          setTimeout(() => {
            this.setState({ 
              errorMessage: null,
              errorPosition: [],
              pool: pool
            });
            this.props.history.push('/recruiter/pool-view-all');
          }, 3000);
        }
        if(navControl === "save-continue") {
          this.setState({
            stepOneFlag: true
          });
        }

        setTimeout(() => {
          this.setState({ 
            currentStep: currentStep + 1,
            errorMessage: null,
            errorPosition: [],
            pool: pool
          });
        }, 3000);
      }
    })
    .catch((error) => {
      ConsoleLog('error',error);
      throw error;
    });
  }

  
  
  /**
 * @desc import the candidate details into specific jobTitle
 * @param null
 * @return null
 */
  getCandidate = () => {
    this.setState({ importButtonDisable: true,importLoader:true, addCandidatebutton: true });
    if(this.state.searchCandidateId.trim() === "") {
      this.setState({ 
        isShowToast: true,
        toastMessage: "Please enter Bullhorn Candidate ID to continue",
        toastVariant: "error",
        toastId: "tid" + (new Date()).getTime() ,
        importLoader:false,
        disableCandidateFields: false,
        
      });

    } else {
      const candidateDetails = {
        candidateId:this.state.searchCandidateId,
        jobId:this.state.pool.jobId,
        s3Key:this.state.s3Key
      }
       axios.post("/galaxy/job/" + this.state.pool.jobId + "/candidate",JSON.stringify(candidateDetails))
        .then((response)=>{
          let showCandidateSuccessful = (response.data.message =="Candidate sucessfully mapped to the job id") ? true : false;
          let toastMessage = "";
          if(showCandidateSuccessful && response.data !=="Invalid parameters") { 
            let candidate = {...response.data.data};
            candidate.candidate_fname = candidate.candidate_fname;
            candidate.candidate_lname = candidate.candidate_lname;
            candidate.initials = candidate.candidate_fname.substring(0,1) + candidate.candidate_lname.substring(0,1);
            
            candidate.caddeddate = candidate.candidate_added_date;
            candidate.candidate_edit_status = "NOT STARTED";
            this.props.onImportCandidateRecruiter(candidate);

            if(this.state.pool.candidates.length === 1) {
              this.handleCandidateSelect(candidate.candidate_id, this.state.pool.jobId);
            }
            toastMessage = "You have added a candidate!";
          } else {
            toastMessage = (response.data.message =="Candidate already mapped to the job id") ? "This Candidate has already been added to this job." :"This Bullhorn Candidate ID is not recognised, please check the ID and try again.";
          }
          

          // this.setState({ showCandidateSuccessful: showCandidateSuccessful,
          //                 candidateError: candidateError,
          //                 importButtonDisable: false,
          //                 searchCandidateId: ""
          //               });

          let emailsList = [...this.state.emailsList];
          emailsList.push({email:this.state.searchCandidateEmail, BHID: this.state.searchCandidateId});
          this.setState({
            emailsList: emailsList
          });
          this.setState({ 
            toastMessage: toastMessage,
            isShowToast: true,
            toastVariant: (showCandidateSuccessful) ? 'success' : 'error',
            importButtonDisable: false,
            importLoader:false,
            searchCandidateId: "",
            searchCandidateEmail:'',
            fileName:'',
            s3Key:'',
            toastId: "tid" + (new Date()).getTime(),
            fileUploaded: true,
            addedCount:'',
            removedCount:'',
            disableCandidateFields: false,
            addCandidatebutton: false
          });
          this.props.setUploadButton(false);
          
        })
        .catch((error) => {
          this.setState({networkError:error})
          ConsoleLog('error',error);
          throw error;
        });
    }  
  }
/**
 * @desc Delete imported candidates confirmation Modal
 * @param index
 * @return null
 */
  deleteCandidateModal=(index,bullhornID)=>{
    let existingEmailList = [...this.state.emailsList];
    var filteredEmailList = existingEmailList.filter(function(el){
      return el.BHID !== bullhornID;
    });
    this.setState({ deleteModal: true, candidateIndex: index, emailsList: filteredEmailList });
  }
/**
 * @desc Close confirmation Modal for delete imported candidate
 * @param index
 * @return null
 */
  closeDeleteModal(){
    this.setState({ deleteModal: false });
  }
  /**
   * @desc Delete imported candidates from list if required
   * @param index
   * @return null
   */
  deleteCandidate = () => {
    let pool = {...this.state.pool};
    let candidateList = [...pool.candidates];
    const candidateIndex= candidateList[this.state.candidateIndex].candidate_id;
  //  interviewList.splice(interviewIndex,1);
  this.setState({deleteImportCandidate:true})
    if(candidateList[this.state.candidateIndex]){
      axios.delete("/galaxy/job/" + this.state.pool.jobId + "/candidate/" + candidateList[this.state.candidateIndex].candidate_id)
      .then((response)=>     
      {   
        let isShowToast = (response.data.message =="Successfully deleted") ? true : false;            
        candidateList.splice(this.state.candidateIndex,1);    
         
        pool.candidates = candidateList;  
        
        this.props.OnRemoveCandidateRecruiter(this.state.candidateIndex);

        if(candidateList.length > 0) {
          const candidateId = candidateList[0].candidate_id;
          this.handleCandidateSelect(candidateId, this.state.pool.jobId);
        }
        
        
        if(isShowToast) {
          this.setState({
            deleteImportCandidate:false,
            pool:pool,
            deleteModal:false ,
            isShowToast:true,
            toastMessage: "Candidate has been removed",
            toastVariant: "success",
            toastId: "tid" + (new Date()).getTime() 
          }); 
        }
      })
      .catch((error) => {
        ConsoleLog('error',error);
        throw error;
      });
    }
  }


  passDeleteCandidate = (id) =>{
    let pool = {...this.state.pool};
    let candidateList = [...pool.candidates];
    const deletedCandidateIndex = candidateList.findIndex((candidate) => candidate.candidate_id === id);
    candidateList.splice(deletedCandidateIndex, 1);
    pool.candidates = candidateList;  
    this.setState({ pool:pool });
  }

 /**
 * @desc Exit the page to dashboard
 * @param e
 * @return null
 */
  handleCancel(e) {
    this.props.history.push('/recruiter/dashboard')
  }

/**
 * @desc Cancel confirmation popup to exit the page
 * @param e
 * @return null
 */
  handleCancelCancel() {
    this.setState({ showCancelWarning: false });
  }
/**
 * @desc Confirmation popup to exit the page
 * @param e
 * @return null
 */
  handleCancelWarningShow() {
    this.setState({ showCancelWarning: true });
  }
  handleContinueModal() {
    this.setState({ showContinueModal: true });
  }
  
  handleContinueModalCancel = (e)  => {
    this.setState({ showContinueModal: false });
  }
  handleContinueModalYes = (e) => {
    this.setState({ showContinueModal: false, searchCandidateId: '', searchCandidateEmail: '', fileUploaded: false, fileName: '', currentStep: this.state.currentStep+1,errorPositioncandidateId: '', errorPositionEmail:'', networkError: '', continueClicked:true });
    this.props.setUploadButton(false);
  }

  /**
 * @desc Exit the page to dashboard
 * @param e
 * @return null
 */
  handleCancelImportCandidate(e) {
    window.scrollTo(0,0);
    this.setState({ showCancelWarningImportCandidate: true });

    //this.handleImportCandidateCancelWarningShow();
    // this.props.history.push('/recruiter/dashboard')
  }
  /**
  * @desc Cancel confirmation popup to exit the page
  * @param e
  * @return null
  */
  handleImportCandidateCancelCancel() {
    this.setState({ showCancelWarningImportCandidate: false });
  }
  /**
  * @desc Confirmation popup to exit the page
  * @param e
  * @return null
  */
  handleImportCandidateCancelWarningShow() {
    this.setState({ showCancelWarningImportCandidate: true });
  }

/**
 * @desc Save the job details and specific imported candidates
 * @param e
 * @return null
 */
  handleComplete = (e) => { 
    const { steps, currentStep } = this.state;
    if(currentStep == 1) {
      if(this.state.searchCandidateEmail || this.state.searchCandidateId || this.state.fileName) {
        this.handleContinueModal();
        return;
      }
      }
    this.setState({
      currentStep: currentStep + 1,
      continueClicked: true
    });
  }
  /**
 * @desc function to permit only numeric value and length on keypress
 * @param e
 * @return null
 */

  handleKeyPressBHJobId = (e) => {
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57)) || this.state.pool.jobBH.length >= 15){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    } 
  }
  /**
 * @desc function to permit only numeric value and length on keypress
 * @param e
 * @return null
 */

handleKeyPressCmpyId = (e) => {
  var e = e || window.event; // for trans-browser compatibility
  var charCode = e.charCode || e.which || e.keyCode;                    
  if ((charCode > 31 && (charCode < 47 || charCode > 57)) || this.state.pool.companyBHId.length >= 15){
    e.preventDefault();
  }
  
  if (e.shiftKey) {
    e.preventDefault();
  } 
  }
/**
 * @desc Fill the JobTitle field input
 * @param e
 * @return null
 */
  handleJobDetailsChange(e) {
    var value;
    if (e.hasOwnProperty('target')) {
      e.preventDefault()
      value = e.target.value;
    } else {
      value = e;
    }

    const name = e.target.id;
    let pool = this.state.pool;
    pool[name] = value;

    let newErrorPosition = [];
    if(name === "companyBHId") {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "companyBHId" && errPosition !== "UnknownCompanyBHId" ));
    } else {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== name);
    }

    this.setState({
      pool: pool,
      errorMessage: null,
      errorPosition: newErrorPosition,
      clientDetails:''
    });

  }
/**
 * @desc Fill the ClientDetails field input
 * @param e
 * @return null
 */
  handleClientDetailsChange(e) {
    const name = e.target.id;
    let pool = this.state.pool;
    pool[name] = e.target.value;

    let newErrorPosition = [];
    if(name === "clientEmail") {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "clientEmailEmpty" && errPosition !== "clientEmailFormat" ));
    } else {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== name);
    }

    this.setState({pool: pool,errorMessage: null, errorPosition: newErrorPosition });
  }
  /**
 * @desc Fill the CandidateId field input
 * @param e
 * @return null
 */
  handleCandidateIdChange(e) {
    // this.setState({importButtonDisable:false});
    const searchCandidateId = e.target.value;
    
    this.setState({ searchCandidateId:searchCandidateId,errorPositioncandidateId:'',fileUploaded:false });
  }
  handleCandidateIdBlur = (e) => {
    const searchCandidateId = e.target.value;
    let errorPositioncandidateId=this.state.errorPositioncandidateId;       
    if(searchCandidateId === ""||!checkValidity(searchCandidateId,'isNumeric') || searchCandidateId === null ) { 
      errorPositioncandidateId = 'candidateId'
      this.setState({searchCandidateId:searchCandidateId,errorPositioncandidateId});
    }
  }
  /**
 * @desc Fill the CandidateEmail field input
 * @param e
 * @return null
 */
   handleCandidateEmailBlur = (e) => {
    // this.setState({importButtonDisable:false});
    const searchCandidateEmail = e.target.value.trim();
    let errorPositionEmail=this.state.errorPositionEmail;
    if(searchCandidateEmail.trim() !=="" && searchCandidateEmail.trim() !==null && !checkValidity(searchCandidateEmail,'isEmail')) {
      errorPositionEmail = 'Email'
      this.setState({errorPositionEmail});
    }
    this.setState({ searchCandidateEmail:searchCandidateEmail });
  }
  handleCandidateEmailChange = (e) => {   
    const searchCandidateEmail = e.target.value;
    
    this.setState({errorPositionEmail:'', searchCandidateEmail:searchCandidateEmail});
  }
  addFile = (file)=> {
    this.setState({addedCount: this.state.addedCount + 1, disableCandidateFields: true});
    if(this.state.searchCandidateId !=='' && file.name.includes(this.state.searchCandidateId.trim())){
      let progressPercent = {...this.state.progressPercent};
    progressPercent[file.name] = 0;
    this.setState({progressPercent});
    this.uploadFile(file, 'cv/' + this.state.pool.jobId + '/' + file.name)
    .then((data)=> {
      let s3Key=data.Key ;    
      if(this.state.removedCount < this.state.addedCount) {
        this.setState({fileName:file.name,s3Key});
      }
    },
    (err) => { 
      ConsoleLog("error",err);
    });
  }
  }
  handleRemoveFile = (file) => {
    this.setState({removedCount: this.state.removedCount + 1, disableCandidateFields: false});
    // const interviewDetails={...this.state.interviewDetails};
    // var attachArray = interviewDetails.interviewAttachments.split(";").filter(item => !item.includes(file));
    // //ConsoleLog("attachArray",attachArray);
    // interviewDetails.interviewAttachments = attachArray.join(";");
    // //ConsoleLog("newArray",interviewDetails.interviewAttachments);
    this.setState({fileName:'' ,networkError:''});
    this.removeFile( 'cv/' + this.state.pool.jobId + '/' + file)
      .then((data)=> {
        // this.autoSaveInterviewDetails();
      },
      (err) => { 
        ConsoleLog("error",err);
      });
  }
  handleAttachClick = ()=> {
    // if(!this.state.interviewDetails.interviewId) {
    //   const interviewDetails={...this.state.interviewDetails};
    //   interviewDetails.interviewTitle = interviewDetails.interviewTitle?interviewDetails.interviewTitle:' ';
    //   this.setState({interviewDetails});
    //   this.autoSaveInterviewDetails('attach');
    // } 
  }
  uploadFile = (file, filePath) => {
    //ConsoleLog("file",file, file.name);
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.cvParseBucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath,
      ContentType: file.type,
      Body: file,
      // ACL: 'public-read'
    };

    return new Promise((resolve, reject)=> {
      S3.upload(params).on('httpUploadProgress',  (progress)=> {
        const progressPercentage = progress.loaded/progress.total * 100;
        let progressPercent = {...this.state.progressPercent};
        progressPercent[file.name] = progressPercentage;
        this.setState({progressPercent});
      }).send( (err, data)=> {
          if (err) {
            reject(err);
          } else {         
            resolve(data);
          }
      });
    });
  }
  removeFile= (filePath) => {
    //ConsoleLog("file",filePath);
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.cvParseBucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath
      // ACL: 'public-read'
    };

    return new Promise(function(resolve, reject) {
      S3.deleteObject(params, function(err, data) {
          if (err) {
              reject(err);
          } else {              
            resolve(data);
          }
      });
    });
  }
    /**
 * @desc function to permit only numeric value and length on keypress
 * @param e
 * @return null
 */
  handleKeyPressCandidateId = (e) => {
    e.target.keyCode === 13 && e.preventDefault();
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57)) || this.state.searchCandidateId.length >= 15){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    } 
    if (e.key === 'Enter') {
      e.preventDefault();
      this.getCandidate();
    };
  }
 /**
 * @desc Add candidate from profile edit 
 * @param null
 * @return null
 */
  handleAddCandidate = () => {
    //this.setState({ currentStep: 1 ,pool:this.state.pool,stepOneFlag:false, stepTwoFlag:true});
    this.setState({ currentStep: 1 ,pool:this.state.pool,stepOneFlag:false, stepTwoFlag:true, searchCandidateId: '', searchCandidateEmail: '', fileUploaded: false, fileName: '', disableCandidateFields: false, s3Key:'', errorPositioncandidateId: '', errorPositionEmail:''});
  }


  componentDidMount() {
    if(this.props.match.params.jobId && this.props.match.params.jobId !== null) {
      this.props.onGetTalentPoolRecruiter(this.props.match.params.jobId,this.props.user);
      this.setState({ currentStep: 2 });
    } else {
      if(this.state.currentStep === 0 && this.props.pool.length > 0) {
        this.props.onClearTalentPool();
      }
    }

    if(this.props.location.state && this.props.location.state.collaborators) {
      const collaborators = [...this.props.location.state.collaborators];
      collaborators.map((collaborator) => { 
        collaborator.initials = collaborator.firstName.charAt(0) + collaborator.lastName.charAt(0);
        collaborator.imageUrl = "";

        if(collaborator.userImage && collaborator.userImage !== null && collaborator.userImage !== "") {
          getS3ImageUrl(collaborator.userImage, this.props.user)
            .then((response) => {
              collaborator.imageUrl = response;
            });
        }
      })
      
      this.setState({
        updatedCollaborators: collaborators,
        collaborators: collaborators
      });
    }
    else {
      let collaborators = [];
      collaborators[0] = {};
      collaborators[0].firstName = this.props.recruiterDetails.user_fname;
      collaborators[0].lastName = this.props.recruiterDetails.user_lname;
      collaborators[0].email = this.props.recruiterDetails.user_email;
      collaborators[0].userId = this.props.recruiterDetails.user_id;
      collaborators[0].initials = this.props.recruiterDetails.user_fname.charAt(0) + this.props.recruiterDetails.user_lname.charAt(0);
      collaborators[0].imageUrl = this.props.userImageSignedUrl;
      this.setState({
        updatedCollaborators: collaborators,
        collaborators: collaborators
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.pool !== this.props.pool && this.props.pool.length > 0 && this.state.currentStep !== 0) {
      let pool = {...this.state.pool};
      if(this.props.match.params.jobId && this.props.match.params.jobId !== null) {
        pool.jobId = this.props.match.params.jobId;
      }
      let candidates = [...this.props.pool];
      candidates.map((candidate) => {
        candidate.candidate_added_date = (!candidate.candidate_added_date && candidate.caddeddate) ? candidate.caddeddate : candidate.candidate_added_date;
        candidate.candidateBH = (!candidate.candidateBH && candidate.candidate_source_id) ? candidate.candidate_source_id : candidate.candidateBH;
        candidate.candidate_name = (!candidate.candidate_name) ? candidate.candidate_fname + ' ' + candidate.candidate_lname : candidate.candidate_name;
      });

      pool.candidates = candidates;

      this.setState({ 
        pool: pool 
      });
    } 
    
    if(this.state.currentStep === 0 && this.state.currentStep !== prevState.currentStep && this.props.pool.length > 0) {
      let pool =  {
        jobTitle: '',
        jobId: '',
        jobBH: '',
        companyBHId:'',
        candidateId:"",
        candidates: []
      };
      this.setState({
        pool:pool
      });
      this.props.onClearTalentPool();
    }
    if(prevState.collaborators !== this.state.collaborators){
      const Collaborators = [...this.state.collaborators];
      const updatedCollaborators = [...this.state.updatedCollaborators];
      const adddedCollaborators = Collaborators.filter(x => !updatedCollaborators.includes(x));
      const deletedCollaborators = updatedCollaborators.filter(x => !Collaborators.includes(x));
      this.setState({adddedCollaborators:adddedCollaborators,deletedCollaborators:deletedCollaborators});
    }
    //ConsoleLog("zeroflag",localStorage.getItem('zeroflag'),this.state.currentStep)
    if(localStorage.getItem('zeroflag')==="true") {
      this.setState({ currentStep: 0});
      localStorage.setItem('zeroflag', false)
    }
  }

  handleCandidateSelect = (candidateId, jobId) => {
    this.props.onSelectCandidate(candidateId,jobId);
    this.props.onViewCandidateRecruiter(candidateId, jobId,this.props.user);
  }

  handleCloseToastNotification = () => {
    this.setState({ 
      isShowToast: false, 
      toastMessage: null, 
      toastVariant: null, 
    });
  }

  render() {
    const { steps, currentStep } = this.state;
    const candidate_id = this.props.match.params.id;
    let companyName = '';

    if(this.state.clientDetails.company_name){
      companyName = this.state.clientDetails.company_name;
    }

    if(this.props.location.state){
      if(this.props.location.state.companyName){
        companyName = this.props.location.state.companyName;
      }
    }

    return (
      <div>
        
        {/* Desktop View Section starts */}	
			    <MediaQuery query="(min-device-width: 769px)">
            <DashboardBar activeLink='manage-jobs'/>
          </MediaQuery>
        {/* Desktop View Section Ends */}
        <div className="dashboard-nav-header-mobile">
          {/* Mobile View Section starts */}	
            <MediaQuery query="(max-device-width: 769px)">
            <Icon icon="left-arrow" className ="recruiter-back-icon " onClick={()=>{this.onClickPrevious()}}/>
            </MediaQuery>
          {/* Mobile View Section Ends */}

          <StepTitle currentStep={ currentStep }
            pool={this.state.pool}
            profileImage={this.state.profileImage}
            handleAddCollaborator={this.handleAddCollaborator}
            jobTitle={this.props.location.state && this.props.location.state.jobTitle ? this.props.location.state.jobTitle : this.state.pool.jobTitle }
            jobBH={this.props.location.state && this.props.location.state.jobBH ? this.props.location.state.jobBH : this.state.pool.jobBH} 
            jobRecUserId={(this.props.location.state && this.props.location.state.jobRecUserId) ? this.props.location.state.jobRecUserId : this.props.recruiterDetails.user_id }
            recruiterDetails={this.props.recruiterDetails}
            updatedCollaborators={this.state.updatedCollaborators}
            companyName={companyName}
            />            
             
        </div>

      	<div className="pool-import">        
          <div className="stepper-cont">
            <div className="stepper">
              <Stepper steps={ steps } activeStep={ currentStep }/>
            </div>
          </div>
          <Steps 
            currentStep={currentStep} 
            fileName={this.state.fileName}
            candidates={this.state.pool.candidates}
            clientDetails={this.state.clientDetails}
            jobId={(this.state.pool && this.state.pool.jobId)? this.state.pool.jobId : ( this.props.location.state && this.props.location.state.jobId) ? this.props.location.state.jobId : ''}
            handleJobDetailsChange={this.handleJobDetailsChange} 
            handleKeyPressCmpyId={this.handleKeyPressCmpyId}
            handleKeyPressBHJobId = {this.handleKeyPressBHJobId}
            handleKeyPressCandidateId = {this.handleKeyPressCandidateId}
            handleClientDetailsChange={this.handleClientDetailsChange} 
            getCandidate={this.getCandidate} 
            networkError={this.state.networkError}
            cvUpload ={this.cvUpload}
            deleteCandidateModal={this.deleteCandidateModal}
            handleCandidateIdChange={this.handleCandidateIdChange}
            handleCandidateIdBlur ={this.handleCandidateIdBlur}
            errorPositioncandidateId={this.state.errorPositioncandidateId}
            errorPositionEmail = {this.state.errorPositionEmail}
            handleCandidateEmailChange = {this.handleCandidateEmailChange}
            addFile = {this.addFile}
            handleRemoveFile = {this.handleRemoveFile}
            handleAttachClick = {this.handleAttachClick}
            progressPercent = {this.state.progressPercent}
            handleCandidateEmailBlur = {this.handleCandidateEmailBlur}
            errorMessage={this.state.errorMessage}
            errorPosition={this.state.errorPosition}
            candidateId={this.state.searchCandidateId}
            candidateEmail = {this.state.searchCandidateEmail}
            jobTitle={this.props.location.state && this.props.location.state.jobTitle ? this.props.location.state.jobTitle : this.state.pool.jobTitle }
            jobBH={this.props.location.state && this.props.location.state.jobBH ? this.props.location.state.jobBH : this.state.pool.jobBH} 
            handleAddCandidate={this.handleAddCandidate}
            passDeleteCandidate={this.passDeleteCandidate}
            handleFetchClientDetails={this.handleFetchClientDetails}
            importButtonDisable={this.state.importButtonDisable}
            importLoader={this.state.importLoader}
            fileUploaded={this.state.fileUploaded}
            emailsList={this.state.emailsList}
            disableCandidateFields={this.state.disableCandidateFields}
            addCandidatebutton={this.state.addCandidatebutton}
            continueClicked={this.state.continueClicked}
          />
          <StepButtons 
            currentStep={currentStep}
            candidates={this.state.pool.candidates} 
            jobTitle ={this.state.pool.jobTitle} 
            jobId={this.state.pool.jobId}
            onClickPrevious={this.onClickPrevious} 
            onClickNext={this.onClickNext} 
            handleCancel={this.handleCancel} 
            handleComplete={this.handleComplete} 
            jobTitle={this.state.pool.jobTitle} 
            jobId={this.state.pool.jobId}
            handleCancelImportCandidate={this.handleCancelImportCandidate}
            disabled={true}
            classDisabled={this.classDisabled}
            clientDetails={this.state.clientDetails}
          />
      	</div>

        <Modal show={this.state.showCancelWarning} onHide={this.handleCancel} className="unsave-modal">
          {/* <Modal.Header closeButton></Modal.Header> */}
          <Modal.Body>
            <p>You have <strong>unsaved data</strong>.<br /><br />
            Are you sure you want to close this screen?</p>
            <Button bsStyle="Primary" onClick={this.handleCancel}>Close Screen</Button> <Button bsStyle="warning" onClick={this.handleCancelCancel}>Continue</Button>
          </Modal.Body>
        </Modal>
        <Modal 
          show={this.state.showContinueModal} 
          onHide={this.handleContinueModalCancel} 
          className="Continue-modal"
          centered
          restoreFocus={false}
        >
            <Modal.Body>
              <p>Are you sure you want to continue? Your progress will not be saved. </p>
              <Button className="ui-button--lesser" bsStyle="Primary" onClick={this.handleContinueModalCancel}>Cancel</Button> 
              <Button className="continue-button-primary"bsStyle="warning" onClick={this.handleContinueModalYes}>Yes</Button>
            </Modal.Body>
        </Modal>
        {/* Modal pop up for successful addition of candidate*
        <Modal show={this.state.showCandidateSuccessful===true} onHide={this.handleSuccessfulHide} backdropClassName="candidate-success-backdrop" className="candidate-Successful-modal">
          <Modal.Body>
            <p>You have added a Candidate<span className="success-image"></span></p>
          </Modal.Body>
        </Modal>
        /* Modal pop up for Unsuccessful addition of candidate*
        <Modal show={this.state.showCandidateSuccessful===false} onHide={this.handleSuccessfulHide} className="candidate-Unsuccessful-modal">
          <Modal.Body>
            <div className="problem"></div>
            <p id="red">There was a problem.</p>
            <p>{this.state.candidateError}</p>
            <Button bsStyle="Primary" onClick={this.handleSuccessfulHide}>Try Again</Button> 
          </Modal.Body>
        </Modal>
         {/* Modal pop up for successful addition of job*
        <Modal show={this.state.showJobSuccessful===true} onHide={this.handleSuccessfulHide} backdropClassName="candidate-success-backdrop" className="job-successful-modal">
          <Modal.Body>
            <p>Job Saved<span className="success-image"></span></p>
          </Modal.Body>
        </Modal>
        {/* Modal pop up for Unsuccessful addition of job*
        <Modal show={this.state.showJobSuccessful===false} onHide={this.handleSuccessfulHide} className="candidate-Unsuccessful-modal">
          <Modal.Body>
            <div className="problem"></div>
            <p id="red">There was a problem.</p>
            <p>{this.state.errorMessage}</p>
            <Button bsStyle="Primary" onClick={this.handleSuccessfulHide}>Try Again</Button> 
          </Modal.Body>
        </Modal> */}
        {/* Modal pop up for delete candidate*/}
        <Modal restoreFocus={false} className="delete-candidate-modal" show={this.state.deleteModal} backdropClassName="candidate-delete-backdrop" onHide={()=>this.closeDeleteModal()}>
          <div className="candidate-delete">
            <Modal.Body>
              <p>Are you sure you want to remove this Candidate?</p>
            <Button className="cancel-delete" onClick={()=>this.closeDeleteModal()}>Cancel</Button> <Button className="confirm-delete" disabled={this.state.deleteImportCandidate?true:false} onClick={()=>this.deleteCandidate()}>Yes</Button>    
            </Modal.Body>
          </div>
        </Modal> 
         {/* Modal pop up for successful delete of candidate*
         <Modal show={this.state.showDeleteSuccessful===true} onHide={this.handleSuccessfulHide} backdropClassName="candidate-delete-success-backdrop" className="candidate-delete-Successful-modal">
          <Modal.Body>
            <p>Candidate has been removed<span className="success-image"></span></p>
          </Modal.Body>
          </Modal> */}

        <Modal restoreFocus={false} show={this.state.showCancelWarningImportCandidate} onHide={()=>this.handleImportCandidateCancelCancel()} className="cancel-modal">
          {/* <Modal.Header closeButton></Modal.Header> */}
          <Modal.Body>
            <p>Are you sure?</p>
            <Button uistyle="lesser" className="cancel-cancel" onClick={()=>this.handleImportCandidateCancelCancel()}>No</Button> 
            <Button uistyle="primary" onClick={this.handleCancel}>Yes</Button>
          </Modal.Body>
        </Modal>
        <ToastNotification 
          isShowToast={this.state.isShowToast} 
          message={this.state.toastMessage} 
          variant={this.state.toastVariant} 
          onClose={this.handleCloseToastNotification}
          toastId= {this.state.toastId} 
        />
        <InviteCollaborator 
          show={this.state.addCollaboratorModal} 
          jobTitle={this.props.location.state && this.props.location.state.jobTitle ? this.props.location.state.jobTitle : this.state.pool.jobTitle }
          jobBH={this.props.location.state && this.props.location.state.jobBH ? this.props.location.state.jobBH : this.state.pool.jobBH} 
          collaboratorSearchParam={this.state.collaboratorSearchParam}
          collaboratorSearchResults={this.state.collaboratorSearchResults}
          cancelAddCollaborator={this.cancelAddCollaborator}
          collaboratorSearchHandler={this.collaboratorSearchHandler}
          onSelectCollaborator={this.onSelectCollaborator}
          collaborators={this.state.collaborators}
          updatedCollaborators={this.state.updatedCollaborators}
          adddedCollaborators={this.state.adddedCollaborators}
          deletedCollaborators={this.state.deletedCollaborators}
          updateCollaborator={this.updateCollaborator}
          closeSuggestion={this.handleClearCollaboratorSearchParam}
          ownerUserId={this.props.recruiterDetails.user_id}
          deleteCollaborator={this.deleteCollaborator}
        />
      </div>
    )
  }
}



/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => ({
  recruiterDetails: state.clientProfile.clientDetails,
  pool: state.talentPool.pool,
  userImageSignedUrl: state.clientProfile.userImageSignedUrl,
  attributes: state.cognito.attributes,
  user: state.cognito.user,
});

/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
  return {
    onGetTalentPoolRecruiter: (jobTitleId,user) => dispatch(actions.getTalentPoolRecruiter(jobTitleId,user)),
    onImportCandidateRecruiter: (candidate) => dispatch(actions.importCandidateRecruiter(candidate)),
    OnRemoveCandidateRecruiter:(candidateIndex) =>dispatch(actions.removeCandidateRecruiter(candidateIndex)),
    onSelectCandidate: (candidateId) => dispatch(actions.viewCandidate(candidateId)),
    onViewCandidateRecruiter: (candidateId, jobTitleId,user) => dispatch(actions.viewCandidateRecruiter(candidateId, jobTitleId,user)),
    onClearTalentPool: () => dispatch(actions.clearTalentPoolRecruiter()),
    onSetPermittedUser: (permittedUser) => dispatch(actions.setPermittedContact(permittedUser)),
    setUploadButton: (status) => dispatch(actions.setUploadButton(status))
  }  
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(PoolImport,axios)));



// WEBPACK FOOTER //
// ./src/container/Recruiter/PoolImport/PoolImport.js